module.exports = __webpack_public_path__ + "static/media/KMH_5413.7c551ad4.jpg";